import type {BlockName} from 'quickstart'

/**
 * Frozen copy of the design-tab organization in the shape `renderDesignTab`
 * reads. It is a copy, not a view onto `tab-structure.ts`, so that editing the
 * organization the reskin renders cannot change what classic draws. Adapting
 * the new shape to this one at the call boundary would have been fewer lines
 * and would have reintroduced exactly the coupling this change removes: a
 * frozen path silently following a live one.
 *
 * Classic is the only caller, and this retires with classic.
 */
export interface TabStructureContent {
  contents?: TabStructureContent[]
  globalAdmin?: BlockName
  params?: string[]
  toggle?: string
}

export interface TabStructure {
  features: {contents: TabStructureContent[]}
  nav: {contents: TabStructureContent[]}
  theme: {contents: TabStructureContent[]}
}

// First level is tabs. These are hard-coded in cubchicken to match.
// Second level is toggles with nested contents.
// Third level is references to block-supplied global admins.
export const tabStructure: TabStructure = {
  features: {
    contents: [
      {toggle: 'Authentication', contents: [{globalAdmin: 'signin'}]},
      {toggle: 'Bookshelf', contents: [{globalAdmin: 'bookshelf'}]},
      {
        toggle: 'Reader',
        contents: [
          {
            params: [
              'readerCSS',
              'readerMarkup',
              'readerLogo',
              'ReaderAppEnabled',
              'ReaderAppHomeLink',
            ],
          },
        ],
      },
      {toggle: 'Redemption codes', contents: [{globalAdmin: 'redemption'}]},
      {toggle: 'Search', contents: [{globalAdmin: 'search'}]},
    ],
  },
  nav: {
    contents: [
      {toggle: 'Main Nav', contents: [{globalAdmin: 'nav'}]},
      {toggle: 'Footer', contents: [{globalAdmin: 'footer'}]},
    ],
  },
  theme: {
    contents: [{globalAdmin: 'theme'}],
  },
}
